module.exports = __webpack_public_path__ + "img/1537674270.03660a21.jpg";